import { immerable } from 'immer';
import { ApiResponseAutonomousAgentDetail, AutonomousAgentDetail } from './AutonomousAgentDetail';
import { ApiResponseOwnerDetail, OwnerDetail } from './OwnerDetail';
import { ApiResponseHouseDetail, HouseDetail } from './HouseDetail';
import { ApiResponsePhotoSession, PhotoSender, PhotoSessionSummary, SessionType } from './PhotoSessionSummary';
import { ApiResponseEntryInfo, EntryInfo } from './EntryInfo';

type ApiResponsePhotoSessionDetail = {
  id: number,
  property: ApiResponseHouseDetail,
  owner: ApiResponseOwnerDetail,
  accessType?: ApiResponseEntryInfo,
  lockbox: boolean,
  keys: string,
  keysExtra: string,
  formattedHour: string,
  startTime: string,
  delayedSession: boolean,
  notes: string,
  status: string,
  photoSender: PhotoSender,
  photosUploaded: boolean,
  photographerName: string,
  photographerRG: string,
  fixed: boolean,
  type: SessionType,
  photographerReschedulable: boolean,
  lastPhotographerReschedule?: boolean,
  photographerReschedulesCount?: number,
  autonomousAgent: ApiResponseAutonomousAgentDetail,
  condoName: string,
}

export class PhotoSessionDetail extends PhotoSessionSummary {
  entryInfo: EntryInfo;
  photographerName: string;
  notes: string;
  lockbox: boolean;
  photographerReschedulable: boolean;
  lastPhotographerReschedule?: boolean;
  photographerReschedulesCount?: number;
  autonomousAgent: AutonomousAgentDetail;
  condoName: string;
  startTime: string;

  [immerable] = true;

  constructor(apiResponsePhotoSession: ApiResponsePhotoSessionDetail) {
    super(apiResponsePhotoSession as ApiResponsePhotoSession)
    this.house = new HouseDetail(apiResponsePhotoSession.property);
    this.owner = new OwnerDetail(apiResponsePhotoSession.owner);
    this.fixed = apiResponsePhotoSession.fixed;
    this.photographerName = apiResponsePhotoSession.photographerName;
    this.notes = apiResponsePhotoSession.notes;
    this.lockbox = apiResponsePhotoSession.lockbox;
    this.photographerReschedulable = apiResponsePhotoSession.photographerReschedulable;
    this.lastPhotographerReschedule = apiResponsePhotoSession.lastPhotographerReschedule;
    this.photographerReschedulesCount = apiResponsePhotoSession.photographerReschedulesCount;
    this.startTime = apiResponsePhotoSession.startTime;

    if (apiResponsePhotoSession.accessType) {
      this.entryInfo = new EntryInfo(apiResponsePhotoSession.accessType);
    }

    if(apiResponsePhotoSession.autonomousAgent) {
      this.autonomousAgent = new AutonomousAgentDetail(apiResponsePhotoSession.autonomousAgent);
    }

    if (apiResponsePhotoSession.condoName) {
      this.condoName = apiResponsePhotoSession.condoName;
    }
  }
}
